import Description from 'src/components/description-block/description';
import Card from 'src/components/form/search/cards/card';
import CardBody from 'src/components/form/search/cards/card-body';
import CardFooter from 'src/components/form/search/cards/card-footer';
import CardHeader from 'src/components/form/search/cards/card-header';
import Complaint from 'src/pages/complaint/complaint';
import { fireEvent } from 'src/utils/analytics/google';
import { openInNewTab } from 'src/utils/helper';
import css from './course.module.scss';
import { CourseItem } from './types';
import { ComplaintEntityType } from 'src/constants/complaint-entity-type';

interface CourseProps {
  course: CourseItem;
}

export default function Course({ course }: Readonly<CourseProps>) {
  function handleCourseClick() {
    fireEvent('view_course', {
      title: course.title,
      url: course.url
    });
    openInNewTab(course.url);
  }

  const wrapper = (
    complaint: JSX.Element,
    onMouseEnter: React.MouseEventHandler<HTMLDivElement> | undefined,
    onMouseLeave: React.MouseEventHandler<HTMLDivElement> | undefined
  ) => (
    <Card
      key={course.id}
      className={css.course}
      onClick={handleCourseClick}
      hoverBorder='bottom'
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <CardHeader className={css.imageContainer}>
        {complaint}
        <img src={course.imgUrl} alt={course.title} />
      </CardHeader>
      <CardBody className={css.textContainer} overflowEllipsis>
        <div className={css.title}>{course.title}</div>
        <Description description={course.description} />
      </CardBody>
      <CardFooter className={css.logoFooter}>
        <img src={course.logoUrl} alt={course.vendor} />
        <span>{course.vendor}</span>
      </CardFooter>
    </Card>
  );

  return (
    <Complaint
      key={course.id}
      entityId={course.id}
      entityType={ComplaintEntityType.COURSE}
      targetTitle={course.title}
      wrapper={wrapper}
    />
  );
}
